import { render } from "./deliveryChallan.vue?vue&type=template&id=8c19bea6&scoped=true"
import script from "./deliveryChallan.vue?vue&type=script&lang=js"
export * from "./deliveryChallan.vue?vue&type=script&lang=js"

import "./deliveryChallan.vue?vue&type=style&index=0&id=8c19bea6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c19bea6"]])

export default __exports__